import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageHeaderComponent } from './page-header.component';
import { RouterModule } from '@angular/router';
import { ShortenModule } from '../pipes/shorten/shorten.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  declarations: [
    PageHeaderComponent
  ],
  imports: [
    RouterModule,
    CommonModule,
    ShortenModule,
    NgbModule
  ],
  exports: [
    PageHeaderComponent
  ]
})
export class PageHeaderModule { }
